"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.mapStateToProps = exports.PulseAnnouncementsTab = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _PulseAnnouncementMessage = _interopRequireDefault(require("../message/PulseAnnouncementMessage"));

var _IllustratedMessage = _interopRequireDefault(require("@react/react-spectrum/IllustratedMessage"));

require("./PulseAnnouncementsTab.scss");

var _reactRedux = require("react-redux");

var AnnouncementSelectors = _interopRequireWildcard(require("../../store/reducers/AnnouncementReducer"));

var NotificationSelectors = _interopRequireWildcard(require("../../store/reducers/NotificationReducer"));

var AnnouncementActions = _interopRequireWildcard(require("../../store/actions/actions"));

var _NoContent = _interopRequireDefault(require("../../resources/NoContent.js"));

var _adobeIntlReact = _interopRequireWildcard(require("@adobe/adobe-intl-react"));

var localizationStrings = _interopRequireWildcard(require("./__localization__/PulseAnnouncementsTab"));

var _Wait = _interopRequireDefault(require("@react/react-spectrum/Wait"));

var _PulseUtil = _interopRequireDefault(require("../../util/PulseUtil"));

var _metrics = _interopRequireDefault(require("@exc/runtime/metrics"));

/************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************/

/**
 * Announcements tab (as seen in pulse widget)
 */
var PulseAnnouncementsTab =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(PulseAnnouncementsTab, _Component);

  function PulseAnnouncementsTab() {
    var _this;

    (0, _classCallCheck2.default)(this, PulseAnnouncementsTab);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PulseAnnouncementsTab).call(this));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderNoNewAnnouncements", function () {
      return _react.default.createElement(_IllustratedMessage.default, {
        description: _react.default.createElement(_adobeIntlReact.FormattedMessage, {
          messageId: "NoAnnouncements",
          defaultMessage: "You have no announcements",
          description: "No Announcements"
        }),
        illustration: _react.default.createElement(_NoContent.default, null)
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderAnnouncement", function (announcement) {
      return _react.default.createElement("div", {
        className: "pulse-widget-announcement-message-container"
      }, _react.default.createElement(_PulseAnnouncementMessage.default, {
        pulseMessageObject: announcement,
        locale: _this.props.locale
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderNewListHeader", function (length) {
      return _react.default.createElement("div", {
        className: "pulse-widget-announcements-list-section-header"
      }, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
        messageId: "New",
        defaultMessage: "NEW",
        description: "New Subheading"
      }), " (".concat(length, ")"));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderListBody", function (list) {
      var AnnouncementsList = [];
      list.forEach(function (announcement, key) {
        AnnouncementsList.push(_react.default.createElement("li", {
          key: key
        }, _this.renderAnnouncement(announcement)));
      });
      return _react.default.createElement("ul", {
        className: "pulse-widget-announcements-list-style"
      }, AnnouncementsList);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderNewAnnouncements", function (AnnouncementsList) {
      if (AnnouncementsList.new.length != 0) {
        return _react.default.createElement("div", {
          className: "pulse-widget-new-announcements"
        }, _this.renderNewListHeader(AnnouncementsList.new.length), _this.renderListBody(AnnouncementsList.new), AnnouncementsList.earlier.length > 0 && _react.default.createElement("div", {
          className: "pulse-widget-announcements-list-section-header announcement-earlier-section"
        }, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
          messageId: "Earlier",
          defaultMessage: "EARLIER",
          description: "Earlier Subheading"
        })));
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderEarlierAnnouncements", function (AnnouncementsList) {
      return _react.default.createElement("div", {
        className: "pulse-widget-earlier-announcements"
      }, _this.renderListBody(AnnouncementsList));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderAnnouncementsList", function (AnnouncementsList, lastSeenTimeStamp) {
      var announcements = _PulseUtil.default.filterAnnouncements(AnnouncementsList, lastSeenTimeStamp);

      return _react.default.createElement("div", {
        className: "pulse-widget-announcements-tab-list-container"
      }, _this.renderNewAnnouncements(announcements), _this.renderEarlierAnnouncements(announcements.earlier));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderAnnouncements", function () {
      if (!_this.props.announcementsList) {
        return _react.default.createElement(_Wait.default, {
          centered: true
        });
      }

      if (_this.props.announcementsList.length == 0) {
        return _this.renderNoNewAnnouncements();
      } else {
        return _this.renderViewAllAnnouncements(_this.props.announcementsList, _this.props.lastSeenTimeStamp);
      }
    });
    _this.metrics = _metrics.default.create("exc.pulse.components.tabs.PulseAnnouncementsTab");
    return _this;
  }

  (0, _createClass2.default)(PulseAnnouncementsTab, [{
    key: "renderViewAllAnnouncements",
    value: function renderViewAllAnnouncements(status, lastSeenTimeStamp) {
      this.metrics.event("flyout.annoucements.renderAll", {
        region: window.config && window.config.region
      });
      return _react.default.createElement("div", {
        className: "pulse-widget-announcements-tab-container"
      }, this.renderAnnouncementsList(status, lastSeenTimeStamp));
    }
  }, {
    key: "render",

    /**
     * render method of pulse Announcements Tab
     * Displays the list of new and earlier announcements
     */
    value: function render() {
      return _react.default.createElement(_adobeIntlReact.default, {
        locale: this.props.locale,
        localeData: localizationStrings
      }, _react.default.createElement("div", {
        className: "pulse-announcements-tab-list"
      }, this.renderAnnouncements()));
    }
    /**
     * on Mounting Announcements Tab component
     */

  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                AnnouncementActions.onAnnouncementTabMount();

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
    /**
     * on unMounting Announcements Tab component
     * functionalities: reset the last seen time stamp
     */

  }, {
    key: "componentWillUnmount",
    value: function () {
      var _componentWillUnmount = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                AnnouncementActions.onAnnouncementTabUnmount();

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function componentWillUnmount() {
        return _componentWillUnmount.apply(this, arguments);
      }

      return componentWillUnmount;
    }()
  }]);
  return PulseAnnouncementsTab;
}(_react.Component);
/**
 * mapping to store
 * @param {JSONObject} state
 */


exports.PulseAnnouncementsTab = PulseAnnouncementsTab;

var mapStateToProps = function mapStateToProps(state) {
  return {
    announcementsList: AnnouncementSelectors.getAnnouncements(state),
    lastSeenTimeStamp: AnnouncementSelectors.getLastAnnouncementSeenTimeStamp(state),
    locale: NotificationSelectors.getLocale(state)
  };
};

exports.mapStateToProps = mapStateToProps;

var _default = (0, _reactRedux.connect)(mapStateToProps)(PulseAnnouncementsTab);

exports.default = _default;